/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import "./App.less";

import { Alert, Button, Col, Layout, message, Row, Spin } from "antd";
import { H } from "highlight.run";
import { useEffect, useState, useRef } from "react";
import {
  Link,
  Route,
  Routes,
  useNavigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import { GlobalModalProvider } from "./components/GlobalModalContext/GlobalModalContext";
import DiscordAllSet from "./components/DiscordAllSet/DiscordAllSet";
import DiscordPickGuild from "./components/DiscordPickGuild/DiscordPickGuild";
import DiscordBotAdded from "./components/DiscordBotAdded/DiscordBotAdded";
import Onboarding, {
  setOnboardingStatus,
  useOnboardingStatus,
} from "./components/Onboarding/Onboarding";
import SlackAdded from "./components/SlackAdded/SlackAdded";
import SlackPermissions from "./components/SlackPermissions/SlackPermissions";
import SlackPermissionsAdmin from "./components/SlackPermissions/SlackPermissionsAdmin";
import SlackPermissionsMember from "./components/SlackPermissions/SlackPermissionsMember";
import SlackReAuthorized from "./components/SlackReAuthorized/SlackReAuthorized";
import SlackSignedIn from "./components/SlackSignedIn/SlackSignedIn";
import { getSupaClient } from "./lib/supabase";
import DotsFishLoading from "./components/DotsFishLoading/DotsFishLoading";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import SignIn from "./pages/SignIn";
import DiscordEditorSandbox from "./components/TextEditor/DiscordEditorSandbox";
import Stories from "../stories";
import OAuthSignUp from "./pages/OAuthSignUp";
import { checkAccess } from "./lib/admin";
import useGuilds from "./components/Settings/useGuilds";
import AddDiscord from "./components/AddDiscord/AddDiscord";
import SelectTeams from "./components/SelectTeams/SelectTeams";
const { Content } = Layout;

export const fetchAllTeams = async (supabase, session) => {
  await supabase.auth.refreshSession();
  // using fetch to get all teams end point /guilds/dots
  const response = await fetch(`${process.env.REACT_APP_API_URL}/guilds/dots`, {
    headers: {
      Authorization: `Bearer ${session.access_token}`,
    },
  });

  const data = await response.json();
  const userSlackTeams = data.teams.userSlackTeams;
  const userDiscordTeams = data.teams.userDiscordTeams;
  return { userSlackTeams, userDiscordTeams };
};

export const WarningWithSignIn = (props) => {
  const navigate = useNavigate();
  return (
    <div>
      <Content align="middle">
        <Row style={{ marginTop: "100px" }}>
          <Col span={8} offset={8}>
            <Alert
              message={props.title}
              description={props.description}
              type={props.type}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>
          <Col span={8} offset={8}>
            <Button
              type="link"
              onClick={() => {
                navigate("/signin");
              }}
            >
              Back to Sign In{" "}
            </Button>
          </Col>
        </Row>
      </Content>
    </div>
  );
};

const NotApproved = (props) => (
  <div>
    <Content align="middle">
      <Row style={{ marginTop: "100px" }}>
        <Col span={8} offset={8}>
          <Alert
            message="Need admin approval."
            description="Your user account was added with Sign In with Slack and is awaiting approval. Please message us at hello@dots.community or have your Slack admin contact us to approve your account!"
            type="error"
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col span={8} offset={8}>
          <Button type="link" onClick={props.backToSignIn}>
            Back to Sign In{" "}
          </Button>
        </Col>
      </Row>
    </Content>
  </div>
);

const Loading = () => (
  <div>
    <Content align="middle">
      <Row style={{ marginTop: "100px" }}>
        <Col span={8} offset={8}>
          <DotsFishLoading />
        </Col>
      </Row>
    </Content>
  </div>
);

const PrivateRoute = ({ component }) => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [sessionExists, setSessionExists] = useState(false);
  const [workspaceExists, setWorkspaceExists] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [platform, setPlatform] = useState("slack"); // default to Slack
  const [errorMessage, setErrorMessage] = useState(false);
  const navigate = useNavigate();
  const [errorCode, setErrorCode] = useState("");
  const dotsBotExists = useRef(null);
  const { dotsBotsExistsQuery } = useGuilds();
  const session = supabase.auth.session();

  const response = dotsBotsExistsQuery(localStorage.getItem("guild-id"));

  const {
    isLoading: dotsBotsStatusLoading,
    isError: dotsBotsStatusError,
    data,
  } = response;
  if (data) {
    dotsBotExists.current = data.botExists;
  }
  const onboardingStatus = useOnboardingStatus(supabase.auth.user());

  const checkSessionWorkspace = async () => {
    const session = supabase.auth.session();
    // check session
    if (session && session.user) {
      // set posthog email
      window.posthog.people.set({
        email: session.user.email,
      });
      // set highlight email
      H.identify(session.user.email);
      window.pendo.initialize({
        visitor: {
          id: session.user.email, // Required if user is logged in, default creates anonymous ID
        },
        account: {
          id: session.user.email, // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
        },
      });

      const teamToken = localStorage.getItem("team-id");
      const guildToken = localStorage.getItem("guild-id");
      const allTeams = localStorage.getItem("teams"); // list of discord/slack teams
      const userApproved = localStorage.getItem("approved");

      //set segment email and params
      window.analytics.identify(session.user.id, {
        email: session.user.email,
        teamId: teamToken || guildToken,
        platform: teamToken ? "slack" : "discord",
      });

      // check if they have a team token + user is approeved
      if (allTeams && userApproved === "true" && (teamToken || guildToken)) {
        // check if the user is approved
        setWorkspaceExists(true);
        setSessionExists(true);
        setLoading(false);
        setIsApproved(true);
        // set team Id
        H.identify(session.user.email, {
          teamId: teamToken || guildToken,
        });
        // check if workspace is set, if not logout and display warning
        // note: this is intended to be temporary as we migrate over to workspaces (sc-1083)
      }
      // no team token or user isn't approved
      else {
        let { userSlackTeams, userDiscordTeams } = await fetchAllTeams(
          supabase,
          session
        );

        // ADMIN ONLY
        if (checkAccess()) {
          userDiscordTeams = await supabase
            .from("discord_users")
            .select(
              "key:discord_id, discord_id, guild(discord_id, name, workspace), email, approved, username"
            )
            .match({ workspace: session.user.app_metadata.workspace });

          userSlackTeams = await supabase
            .from("users")
            .select(
              "key:slack_id, slack_id, email, team (slack_id, name, alias, workspace ( paid_user, trial_end), created_at), approved"
            )
            .match({ workspace: session.user.app_metadata.workspace });
        }
        // if error from supabase
        if (userSlackTeams.error || userDiscordTeams.error) {
          console.log("error with userTeams", userSlackTeams.error);
          setIsApproved(false);
          setWorkspaceExists(false);
          setSessionExists(true);
          setLoading(false);
          setErrorMessage(true);
          setErrorCode("10");
        }

        // check if there are multiple teams. Incase you have a auth session who is signed in but don't have a user table
        if (userSlackTeams.data && userSlackTeams.data.length) {
          const firstAppUser = userSlackTeams.data[0];
          // set the teams connected to user

          // append the discord and slack teams, if there are discord teams
          let userTeams = userSlackTeams.data;
          if (userDiscordTeams.data) {
            userTeams = userTeams.concat(userDiscordTeams.data);
          }
          // local storage
          localStorage.setItem("teams", JSON.stringify(userTeams));
          // check if the first returned user is approved
          if (!firstAppUser.approved) {
            setIsApproved(false);
            setWorkspaceExists(true);
            setSessionExists(true);
            setLoading(false);
          }
          // if the first returned user isn't approved, get the first team
          else if (firstAppUser.team) {
            // set to first team returned for now
            localStorage.setItem("team-id", firstAppUser.team.slack_id);
            localStorage.setItem("slack-id", firstAppUser.slack_id);
            localStorage.setItem("platform", "slack");
            localStorage.setItem("team-name", firstAppUser.team.name);
            localStorage.setItem("paid", firstAppUser.team.workspace.paid_user);
            localStorage.setItem(
              "trial-end",
              firstAppUser.team.workspace.trial_end
            );
            localStorage.setItem(
              "team-created-at",
              firstAppUser.team.created_at
            );
            localStorage.setItem("approved", true);
            window.analytics.identify(session.user.id, {
              team: firstAppUser.team.name,
              platform_user_id: firstAppUser.slack_id,
              email: session.user.email,
              platform: "slack",
            });
            window.analytics.track("Signed in", {
              slackId: `${firstAppUser.slack_id}`,
              teamId: `${firstAppUser.team.id}`,
              teamName: `${firstAppUser.team.name}`,
            });
            window.posthog.identify(
              `${firstAppUser.team.name}-${firstAppUser.slack_id}`
            );
            H.identify(session.user.email, {
              team_id: firstAppUser.team.id,
            });
            window.posthog.capture("Signed in");
            setIsApproved(true);
            setOnboardingStatus(session.user.email, "onboarded");
            setWorkspaceExists(true);
            setSessionExists(true);
            setLoading(false);
          }
          // user isn't approved or doesn't have a team - unknown state
          else {
            setErrorMessage(true);
            setErrorCode("11");
          }
        }
        // user is signed in but they don't have a valid user table entry (for slack) in supabase
        else if (userDiscordTeams.data && userDiscordTeams.data.length) {
          // check discord users
          const userTeams = userDiscordTeams.data;
          localStorage.setItem("teams", JSON.stringify(userTeams));
          const guild = localStorage.getItem("guild-id");
          const discordGuilds = localStorage.getItem("discord-guilds");
          localStorage.setItem("platform", "discord");
          // check if they have a team token + user is approeved
          if (guild && discordGuilds) {
            // check if the user is approved
            setIsApproved(true);
            setWorkspaceExists(true);
            setSessionExists(true);
            setPlatform("discord");
            setLoading(false);
          } else {
            if (userDiscordTeams.data?.length) {
              //Find the first server that has the same workspace as the user
              const firstDiscordUser = userDiscordTeams.data.find(
                (user) =>
                  user.guild.workspace === session.user.app_metadata.workspace
              );

              localStorage.setItem(
                "discord-guilds",
                JSON.stringify(firstDiscordUser.data)
              );

              localStorage.setItem("guild-name", firstDiscordUser.guild.name);
              localStorage.setItem(
                "discord-username",
                firstDiscordUser.username
              );
              localStorage.setItem(
                "guild-id",
                firstDiscordUser.guild.discord_id
              );
              localStorage.setItem(
                "guild-is-active",
                firstDiscordUser.guild.is_active
              );
              localStorage.setItem("discord-id", firstDiscordUser.discord_id);

              localStorage.setItem("platform", "discord");
              localStorage.setItem("approved", true);
              window.analytics.identify(session.user.id, {
                team: firstDiscordUser.guild.name,
                platform_user_id: firstDiscordUser.discord_id,
                email: session.user.email,
                platform: "discord",
              });
              H.identify(session.user.email, {
                teamId: teamToken || guildToken,
                team: firstDiscordUser.guild.name,
                platform_user_id: firstDiscordUser.discord_id,
              });
              setIsApproved(true);
              setWorkspaceExists(true);
              setSessionExists(true);
              setPlatform("discord");
              setLoading(false);
            } else {
              setWorkspaceExists(false);
              setSessionExists(true);
              setLoading(false);
              setIsApproved(false);
            }
          }
        } else {
          window.analytics.track("Error getting discord or slack teams");
          setWorkspaceExists(false);
          setSessionExists(true);
          setLoading(false);
          setIsApproved(false);
        }
      }
    }
    // else there is no session
    else {
      setLoading(false);
    }
  };
  useEffect(() => {
    setTimeout(checkSessionWorkspace, 1000);
  }, []);

  useEffect(() => {
    if (
      supabase.auth.session() &&
      onboardingStatus.isFetched &&
      onboardingStatus.data !== "onboarded" &&
      // `slack-await-approval` is processed right inside this component, a warning message will be displayed
      onboardingStatus.data !== "slack-await-approval"
    ) {
      navigate("/onboarding");
    }
  }, [onboardingStatus.isFetched, onboardingStatus.data]);

  const backToSignup = async () => {
    await supabase.auth.signOut().catch(console.error);
    navigate(`/signup`);
  };

  const backToSignIn = async () => {
    await supabase.auth.signOut().catch(console.error);
    navigate(`/signin`);
  };

  let finalComponent = <SignIn checkSessionWorkspace={checkSessionWorkspace} />;
  if (loading || (dotsBotsStatusLoading && localStorage.getItem("guild-id"))) {
    finalComponent = <Loading />;
  }
  // if there is a session
  else if (sessionExists) {
    if (localStorage.getItem("guild-is-active") === "false") {
      finalComponent = (
        <WarningWithSignIn
          title={"Guild is not active"}
          description={
            <>
              <p>
                Sorry, your guild <b>{localStorage.getItem("guild-name")}</b> is
                not active. If you want to use Dots, please contact us at
                hello@dots.community.com.
                {JSON.parse(localStorage.getItem("teams")).length > 1 && (
                  <>
                    <b className="inline-block p-4">
                      Or you can select another Guild
                    </b>
                    <SelectTeams disableTeamNameTruncate={true} />
                  </>
                )}
              </p>
            </>
          }
          type="error"
        />
      );
    } else if (dotsBotsStatusError === true) {
      finalComponent = (
        <WarningWithSignIn
          title={"Error getting Dots bot"}
          description={
            <>
              Sorry, we couldn't get the status of your bot. Try again or
              contact us at hello@dots.community.com
            </>
          }
          type="error"
        />
      );
    } else if (dotsBotExists.current === false) {
      finalComponent = (
        <WarningWithSignIn
          title={"Dots Bot not found"}
          description={
            <>
              <p>
                Dots bot is not in your guild{" "}
                <b>{localStorage.getItem("guild-name")}</b>. Please add it
                clicking the button below.
                <div className="p-4">
                  <AddDiscord justify="center" />
                </div>
                {JSON.parse(localStorage.getItem("teams")).length > 1 && (
                  <>
                    <b className="inline-block p-4">
                      Or you can select another Guild
                    </b>
                    <SelectTeams disableTeamNameTruncate={true} />
                  </>
                )}
              </p>
            </>
          }
          type="error"
        />
      );
      // if a workspace exists
    } else if (workspaceExists) {
      if (isApproved) {
        // if (platform === "slack") {
        //   finalComponent = component;
        // } else if (platform === "discord") {
        //   finalComponent = DiscordHome;
        // }
        finalComponent = <Outlet />;
      } else {
        finalComponent = <NotApproved backToSignIn={backToSignIn} />;
      }
    }

    // error message from supabase
    else if (errorMessage) {
      finalComponent = (
        <div style={{ margin: "auto", padding: 30 }}>
          <Row align="middle" justify="center">
            <Alert
              message="Error logging in"
              type="error"
              description={
                <p>
                  Please retry or contact hello@dots.community. Code:{" "}
                  {errorCode}
                </p>
              }
            />
          </Row>
          <Button type="primary" onClick={backToSignIn}>
            Back to Sign In
          </Button>
        </div>
      );
    } else if (onboardingStatus.data === "slack-await-approval") {
      finalComponent = (
        <WarningWithSignIn
          title={"Slack await approval"}
          description={
            <>
              Since you are a team member, we will need your admin to confirm
              first. Please have admin to reach out to us to approve you.
            </>
          }
          type="info"
        />
      );
    } else {
      // If the user has a session but no workspace, we redirect them to the onboarding page
      setOnboardingStatus(session.user.email, "choose-platform");
      finalComponent = <Onboarding />;
    }
  }

  return finalComponent;
};

function App() {
  const location = useLocation();
  return (
    <>
      <Routes>
        <Route exact path="/signin" element={<SignIn />} />
        <Route exact path="/signup" element={<Signup />} />
        <Route exact path="/oauth-signup" element={<OAuthSignUp />} />
        <Route exact path="/onboarding" element={<Onboarding />} />
        <Route exact path="/onboarding/slack" element={<SlackPermissions />} />
        <Route
          exact
          path="/onboarding/discord"
          element={<DiscordPickGuild />}
        />
        <Route path="/onboarding/discord/all-set" element={<DiscordAllSet />} />
        <Route
          path="/onboarding/discord/bot-added"
          element={<DiscordBotAdded />}
        />
        <Route
          exact
          path="/onboarding/slack/admin"
          element={<SlackPermissionsAdmin />}
        />
        <Route
          exact
          path="/onboarding/slack/member"
          element={<SlackPermissionsMember />}
        />
        <Route exact path="/welcome" element={<SignIn />} />
        <Route
          exact
          path="/auth/slackpermissions"
          element={<SlackPermissions />}
        />
        <Route
          exact
          path="/auth/slackpermissions/admin"
          element={<SlackPermissionsAdmin />}
        />
        <Route
          exact
          path="/auth/slackpermissions/member"
          element={<SlackPermissionsMember />}
        />
        <Route path="/auth/reauthorized" element={<SlackReAuthorized />} />
        <Route exact path="/auth/added" element={<SlackAdded />} />
        <Route exact path="/auth/signedin" element={<SlackSignedIn />} />

        <Route path="/" element={<PrivateRoute />}>
          {/* Note: GlobalModalProvider has to be added here instead of in Home like most contexts,
          because Home currently uses it */}
          <Route
            path="*"
            element={
              <GlobalModalProvider>
                <Home location={location} />
              </GlobalModalProvider>
            }
          />
          <Route
            path="/"
            element={
              <GlobalModalProvider>
                <Home location={location} />
              </GlobalModalProvider>
            }
          />
        </Route>
        {/* Test route for quickly trying out TriggerEditor with predefined data
        Ideally we want it in Storybook, which, however, is fairly difficult to setup. */}
        {process.env.NODE_ENV === "development" && (
          <Route path="/_stories" element={<Stories />} />
        )}
        {/*Route for testing discord editor component */}

        {process.env.NODE_ENV === "development" && (
          <Route path="/post-message" element={<DiscordEditorSandbox />} />
        )}
      </Routes>
    </>
  );
}

export default App;
